<template>
  <Layout style="height: 100vh">
    <Header class="header">
      <div class="top-side">
        <img
          src="../assets/images/sign.png"
          alt=""
          style="width: 40px; height: 30px; margin-right: 20px"
        />
        <div class="top-title">安讯捷</div>
      </div>
    </Header>
    <router-view></router-view>
  </Layout>
</template>
<script>
import { defineComponent, ref } from "vue";
export default defineComponent({
  setup() {
   
  },
});
</script>
<style lang="less" scoped>
.header {
  background: #fff;
  height: 70px;
  .top-side {
    display: flex;
    align-items: center;
    img {
      margin-left: 100px;
    }
    .top-title {
      height: 70px;
      color: #333333;
      font-size: 25px;
      line-height: 70px;
      font-weight: bold;
    }
  }
  .btn {
    height: 60px;
    line-height: 60px;
    margin-left: auto;
    font-size: 14px;
    margin-right: 20px;
    .name {
      color: #fff;
      margin-right: 20px;
      font-weight: bold;
    }
    .a-btn {
      background: #fff;
      color: #0066ff;
      border-radius: 20px;
      padding: 5px 10px;
      text-decoration: none;
    }
  }
}
.my-side {
  background: #515a6e;
  height: 100%;
  overflow: hidden;
  width: 200px;
  .menu-box {
    height: 100%;
    overflow: auto;
  }
}
.my-content {
  height: auto;
  overflow: auto;
}
</style>
<style>
.ivu-layout-header {
  box-shadow: 0px 0px 7px rgb(230, 230, 230);
  z-index: 1000;
}
</style>
